<template>
	<div>
		<!-- <mainHead :title="mainHeadTitle" @btnClick="addTableData"></mainHead> -->
		<div class="headTabs">
			<el-tabs v-model="activeTab" @tab-click="tabChange">
				<el-tab-pane label="公司配置" value="1" name="1"></el-tab-pane>
				<el-tab-pane label="基础信息" value="2" name="2"></el-tab-pane>
				<el-tab-pane label="资质信息" value="3" name="3"></el-tab-pane>
			</el-tabs>
		</div>
		<el-form inline class="el-form el_dialog_form" label-width="120px" :rules="rulesApi" :model="companyFormData"
			ref="ruleCompanyForm" v-show="activeTab == 1">
			<div class="mianPage">
				<!-- {{adEditTitle}} -->
				<div class="titleRow">{{activeTabName}}</div>
				<div class="splitLine"></div>
				<el-form-item label="公司名称：" prop="name">
					<el-input clearable size="small" placeholder="请输入公司名称" v-model="companyFormData.name" 
					:disabled="isFormDisable"></el-input>
				</el-form-item>
				<el-form-item label="Sass媒体：" prop="isSass">
					<el-select v-model="companyFormData.isSass" clearable size="small" placeholder="请选择是否Sass媒体"
					:disabled="isFormDisable">
						<el-option label="是" :value="1"></el-option>
						<el-option label="否" :value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="账号：" prop="account">
					<el-input clearable size="small" placeholder="请输入账号" v-model="companyFormData.account" 
					:disabled="isFormDisable"></el-input>
				</el-form-item>
				<el-form-item label="密码：" prop="passWord">
					<el-input clearable size="small" placeholder="请输入密码" v-model="companyFormData.passWord"
					:disabled="isFormDisable"></el-input>
				</el-form-item>
				<el-form-item label="合作情况：" prop="cooperationState">
					<el-select v-model="companyFormData.cooperationState" clearable size="small" 
					placeholder="请选择合作情况" :disabled="isFormDisable">
						<el-option label="跟进中" :value="1"></el-option>
						<el-option label="合作中" :value="2"></el-option>
						<el-option label="合作结束" :value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属媒介：" prop="userId">
					<el-select v-model="companyFormData.userId" filterable clearable size="small" 
					placeholder="请选择所属媒介" :disabled="isFormDisable">
						<el-option v-for="item in companyMediumOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="素材审核：" prop="isCheck">
					<el-radio v-model="companyFormData.isCheck" :label="1" :disabled="isFormDisable">展示</el-radio>
					<el-radio v-model="companyFormData.isCheck" :label="0" :disabled="isFormDisable">不展示</el-radio>
				</el-form-item>
				<el-form-item label="审核维度：" prop="checkType">
					<el-radio v-model="companyFormData.checkType" :label="1" :disabled="isFormDisable">公司维度</el-radio>
					<el-radio v-model="companyFormData.checkType" :label="2" :disabled="isFormDisable">APP维度</el-radio>
				</el-form-item>
				<el-form-item label="开票内容：">
					<el-select v-model="companyFormData.invoiceContent" clearable size="small"
					:disabled="isFormDisable">
						<el-option v-for="item in invoiceContSelect" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="文化建设费：">
					<el-switch v-model="companyFormData.cultureConstructionSwitch" :active-value="1" :inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="增值税税点：">
					<el-select v-model="companyFormData.taxPoint" clearable size="small"
					:disabled="isFormDisable">
						<el-option v-for="item in taxPointSelect" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="增值税差价：">
					<el-switch v-model="companyFormData.valueAddTaxSwitch" :active-value="1" :inactive-value="0"></el-switch>
				</el-form-item>
			</div>
			<div class="card-bottom flex_end">
				<el-button @click="closeMediaDialog" size="medium">取消</el-button>
				<el-button type="primary" @click="configInfoSave('ruleCompanyForm',1)" size="medium"
				:disabled="isFormDisable">完成</el-button>
				<el-button type="primary" @click="configInfoSave('ruleCompanyForm',2)" size="medium">下一步</el-button>
			</div>
		</el-form>
		<el-form inline class="el-form el_dialog_form" label-width="120px" :rules="rulesBaseApi" :model="companyFormData"
			ref="ruleCompanyBaseForm" v-show="activeTab == 2">
			<div class="mianPage">
				<!-- {{adEditTitle}} -->
				<div class="titleRow">{{activeTabName}}</div>
				<div class="splitLine"></div>
				<el-form-item label="公司名称：" prop="name">
					<el-input clearable size="small" placeholder="请输入" v-model="companyFormData.name"
					:disabled="isFormDisable"></el-input>
				</el-form-item>
				<el-form-item label="联系人：" prop="contacts">
					<el-input clearable size="small" placeholder="请输入联系人名字" v-model="companyFormData.contacts"
					:disabled="isFormDisable"></el-input>
				</el-form-item>
				<el-form-item label="联系电话：" prop="phone">
					<el-input clearable size="small" placeholder="请输入联系电话" v-model="companyFormData.phone"
					:disabled="isFormDisable"></el-input>
				</el-form-item>
				<el-form-item label="邮箱账号：" prop="email">
					<el-input clearable size="small" placeholder="请输入邮箱账号" v-model="companyFormData.email"
					:disabled="isFormDisable"></el-input>
				</el-form-item>
				<el-form-item label="收件地址：" prop="address">
					<el-input clearable size="small" placeholder="请输入收件地址" v-model="companyFormData.address"
					:disabled="isFormDisable"></el-input>
				</el-form-item>
			</div>
			<div class="card-bottom flex_end">
				<el-button @click="closeMediaDialog" size="medium">取消</el-button>
				<el-button type="primary" @click="backStepToOne()" size="medium" plain>上一步</el-button>
				<el-button type="primary" @click="configInfoSave('ruleCompanyBaseForm',3)" size="medium">下一步</el-button>
			</div>
		</el-form>
		<el-form inline class="el-form el_dialog_form" label-width="150px" :rules="rulesQualificaApi" :model="companyFormData"
			ref="ruleCompanyQualificaForm" v-show="activeTab == 3">
			<div class="mianPage">
				<div class="titleRow">{{activeTabName}}</div>
				<div class="splitLine"></div>
				<el-form-item label="公司名称：" required>
					<div>{{companyFormData.name}}</div>
				</el-form-item>
				<el-form-item label="认证状态：" required>
					<div class="auditStatus flex_start" v-if="companyFormData.authStatus==2">
						<div style="color: #FA9600;">待审核</div>
					</div>
					<div class="auditStatus flex_start" v-if="companyFormData.authStatus==3">
						<div style="color: #05C46D;">认证通过</div>
					</div>
					<div class="auditStatus flex_start" v-if="companyFormData.authStatus==4">
						<div style="color: #FC474C;">认证失败</div>
						<div class="rejectTxt">{{companyFormData.authFailCause}}</div>
					</div>
					<div class="auditStatus flex_start" v-if="companyFormData.authStatus==1">
						<div style="color: #AAAAAA;">待上传</div>
					</div>
				</el-form-item>
				<el-form-item label="证件类型：" required>
					<el-input clearable size="small" disabled v-model="certificateType" ></el-input>
				</el-form-item>
				<el-form-item label="营业执照：" size="small" required>
					<div class="flex_start" style="flex-wrap: wrap;">
						<div class="upload_img" style="margin-top: 8px;" v-show="companyFormData.businessPhotoUrl">
							<el-image class="upload_img" :src="companyFormData.businessPhotoUrl" :preview-src-list="[companyFormData.businessPhotoUrl]"></el-image>
							<div class="closeImgIcon" @click.stop="deletePoster()"><i class="el-icon-error" v-if="companyFormData.authStatus!=2"></i></div>
						</div>
						<el-upload class="upload-demo" ref="upload" v-show="!companyFormData.businessPhotoUrl"
							:before-upload="handleBeforeUpload" :http-request="uploadSetOther" :disabled="isFormDisable"
							action="#" :on-change="function (res,file){return onChangeImg(res,file,1)}"
							:auto-upload="true" :show-file-list="false">
							<div class="addImg flex_center">
								<img src="../../assets/images/uploadImg.png" alt="">
							</div>
							<div slot="tip" class="el-upload__tip">请上传资质编号清晰可见的相关资质照片。支持jpg、png、jpeg格式，大小不超过3MB</div>
						</el-upload>
					</div>
				</el-form-item>
				<el-form-item label="统一社会信用代码：" prop="number">
					<el-input clearable size="small" placeholder="请输入统一社会信用代码" v-model="companyFormData.number"
					:disabled="isFormDisable"></el-input>
				</el-form-item>
				<el-form-item label="法人/经营者：" prop="legalPerson">
					<el-input clearable size="small" placeholder="请输入法人/经营者" v-model="companyFormData.legalPerson"
					:disabled="isFormDisable"></el-input>
				</el-form-item>
				<el-form-item label="证件有效期：" prop="certStatus" required>
					<div>
						<el-radio v-model="companyFormData.certStatus" :label="0"
						:disabled="isFormDisable">固定期限</el-radio>
						<el-radio v-model="companyFormData.certStatus" :label="1"
						:disabled="isFormDisable">无截止日期</el-radio>
					</div>
					<el-date-picker v-model="companyDatePicker" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange" :disabled="isFormDisable"
						range-separator="～" start-placeholder="开始日期" end-placeholder="结束日期" size="small" v-show="companyFormData.certStatus===0">
					</el-date-picker>
				</el-form-item>
				<div class="titleRow">财务信息</div>
				<div class="splitLine"></div>
				<el-form-item label="发票抬头：" prop="invoiceTitle">
					<el-input clearable size="small" placeholder="请输入发票抬头" v-model="companyFormData.invoiceTitle"
					:disabled="isFormDisable"></el-input>
				</el-form-item>
				<el-form-item label="开户银行：" prop="bankAccountName">
					<el-input clearable size="small" placeholder="请输入开户银行" v-model="companyFormData.bankAccountName"
					:disabled="isFormDisable"></el-input>
				</el-form-item>
				<el-form-item label="开户账号：" prop="bankAccount">
					<el-input clearable size="small" placeholder="请输入开户账号" v-model="companyFormData.bankAccount"
					:disabled="isFormDisable"></el-input>
				</el-form-item>
				<el-form-item label="注册地：" prop="bankBranchName">
					<el-input clearable size="small" placeholder="请填写注册地" v-model="companyFormData.bankBranchName"
					:disabled="isFormDisable"></el-input>
				</el-form-item>
				<el-form-item label="联系电话：" prop="receiptPhone">
					<el-input clearable size="small" placeholder="请输入联系电话" v-model="companyFormData.receiptPhone"
					:disabled="isFormDisable"></el-input>
				</el-form-item>
				<el-form-item label="开票内容：">
					<template slot="label">
						<div class="flex_end tipsIcon">
							<el-tooltip effect="dark" content="若不支持，请联系商务" placement="top">
								<img src="../../assets/icon/iconQuestion.png" alt="" />
							</el-tooltip>
							<div>开票内容: </div>
						</div>
					</template>
					<el-select v-model="companyFormData.invoiceContent" clearable size="small"
					:disabled="isFormDisable">
						<el-option v-for="item in invoiceContSelect" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="税点：">
					<el-select v-model="companyFormData.taxPoint" clearable size="small"
					:disabled="isFormDisable">
						<el-option v-for="item in taxPointSelect" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
			</div>
			<div class="card-bottom flex_end">
				<el-button @click="closeMediaDialog" size="medium">取消</el-button>
				<el-button type="primary" @click="backStepToTwo()" size="medium" plain>上一步</el-button>
				<el-button type="primary" @click="configInfoSave('ruleCompanyQualificaForm',4)" size="medium"
				:disabled="isFormDisable">提交审核</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeTab: '1',
				activeTabName: '公司配置',
				adEditTitle: '新建',
				loadTypeSelectData: [], // 加载类型拉下列表
				adTypeOptions: [], // 广告类型下拉选择
				mediaAppOptions: [], // 媒体APP下拉选择列表
				rulesApi:{
					name: [{required: true,message: '请输入公司名称',trigger: 'blur'}],
					isSass: [{required: true,message: '请选择是否Sass媒体',trigger: 'blur'}],
					account: [{required: true,message: '请输入账号',trigger: 'blur'}],
					passWord: [{required: true,message: '请输入密码',trigger: 'blur'}],
					cooperationState: [{required: true,message: '请选择合作情况',trigger: 'blur'}],//合作情况
					userId: [{required: true,message: '请选择所属媒介',trigger: 'blur'}],//所属媒介
				},
				// 模板选择列表
				styleCheckList: [
					{imgs:require('../../assets/images/style1.png'),imgsSelected:require('../../assets/images/styleSelected1.png'),
					name:'上文下图',checked:true},
					{imgs:require('../../assets/images/style2.png'),imgsSelected:require('../../assets/images/styleSelected2.png'),
					name:'上图下文',checked:true},
					{imgs:require('../../assets/images/style3.png'),imgsSelected:require('../../assets/images/styleSelected3.png'),
					name:'文字浮层',checked:true},
					{imgs:require('../../assets/images/style4.png'),imgsSelected:require('../../assets/images/styleSelected4.png'),
					name:'左图右文',checked:true},
					{imgs:require('../../assets/images/style5.png'),imgsSelected:require('../../assets/images/styleSelected5.png'),
					name:'左文右图',checked:true},
				],
				companyFormData: {
					invoiceContent: 1,
					taxPoint: 6,
					certStatus: 1,
					checkType: 1,
					authStatus: 1,
					certType: 1,
					cultureConstructionSwitch: 1,
					valueAddTaxSwitch: 1
				}, // 媒体广告位表单数据
				rulesBaseApi: {
					name: [{required: true,message: '请输入公司名称',trigger: 'blur'}],
				},
				// companyFormBaseData: {
				// 	name: ''
				// },
				rulesQualificaApi: {
					number: [{required: true,message: '请输入统一社会信用代码',trigger: 'blur'}],
					legalPerson: [{required: true,message: '请输入法人/经营者',trigger: 'blur'}],
					invoiceTitle: [{required: true,message: '请输入发票抬头',trigger: 'blur'}],
					bankAccountName: [{required: true,message: '请输入开户银行',trigger: 'blur'}],
					bankAccount: [{required: true,message: '请输入开户账号',trigger: 'blur'}],
				},
				// companyQualificaForm: {},
				isAdEditDialog: false, //广告弹框是否编辑
				styleChecked: false,
				id: '',
				
				companyMediumOptions: [],// 所属媒介选择列表
				
				// 开票内容下拉选择
				invoiceContSelect: [
					{value:1,label:'广告发布费'},
					{value:2,label:'信息服务费'},
				], 
				// 税点下拉选择
				taxPointSelect: [
					{value:1,label:'1%'},
					{value:3,label:'3%'},
					{value:6,label:'6%'},
				],
				
				certificateType: '企业营业执照',
				fileType: ["png", "jpg", "jpeg"],
				fileSize: 3,
				
				companyDatePicker: []
			}
		},
		computed: {
		  isFormDisable() {
		    return this.companyFormData.authStatus == 2;
		  }
		},
		activated(){
			if (this.$route.query.id) {
				this.id = this.$route.query.id
				this.getFormData();
				this.isAdEditDialog = true
				this.adEditTitle = '编辑'
			}else{
				this.activeTab = '1'
				this.companyFormData = {
					invoiceContent: 1,
					taxPoint: 6,
					certStatus: 1,
					checkType: 1,
					authStatus: 1,
					certType: 1,
					cultureConstructionSwitch: 1,
					valueAddTaxSwitch: 1
				}
			}
		},
		mounted() {
			this.getCompanyMediumOption();
			this.getMediaAppOption();
			this.getADTypeOption();
		},
		methods: {
			tabChange(tab, event) {
				this.activeTabName = tab.$options.propsData.label
				// console.log(tab.$options.propsData.label);
				// console.log(event);
			},
			// 获取公司所属媒介选择列表
			async getCompanyMediumOption() {
				let res = await this.$http.get(this.$api.common.companyMediumOption,{flag:1});
				this.companyMediumOptions = res.data
			},
			// 获取媒体APP下拉列表
			async getMediaAppOption() {
				let res = await this.$http.get(this.$api.common.mediaAppOptionFilter);
				this.mediaAppOptions = res.data
			},
			// 获取广告类型下拉列表
			async getADTypeOption() {
				let res = await this.$http.get(this.$api.common.adTypeOption);
				this.adTypeOptions = res.data
			},
			// 获取加载类型下拉列表
			async getloadTypeSelectData(appId){
				let data = {appId:appId}
				let res = await this.$http.get(this.$api.common.mediaAdsOption,data);
				this.loadTypeSelectData = res.data
			},
			// 获取详情信息
			async getFormData() {
				let data = {
					pageNum: 1,
					pageSize: 10,
					id: this.id
				}
				let res = await this.$http.post(this.$api.companyList, data);
				if(res.data.list&&res.data.list.length>0){
					this.companyFormData = res.data.list[0];
					// 证件有效期回显
					if(this.companyFormData.certStatus === 0){
						if(this.companyFormData.certStartDate&&this.companyFormData.certEndDate){
							this.companyDatePicker.push(this.companyFormData.certStartDate);
							this.companyDatePicker.push(this.companyFormData.certEndDate);
						}
					}
				}
			},
			backStepToOne(){
				this.activeTab = '1'
			},
			backStepToTwo(){
				this.activeTab = '2'
			},
			// 表格弹窗关闭
			closeMediaDialog() {
				// this.dialogVisible = false
				if(this.adEditTitle == '新建'){
					let msg = '退出后已编辑的内容将不会保留，请确认您是否 退出。'
					let dialogtitle = '确定退出' + this.adEditTitle + '公司吗？';
					this.$confirm(msg, dialogtitle, {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.go(-1);
					}).catch();
				}else{
					this.$router.go(-1);
				}
			},
			// 公司配置信息保存
			configInfoSave(formName,type){
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						if(type == 1){
							this.confirmCompanyInfo(this.companyFormData);
						}else if(type == 2){
							this.activeTab = '2'
						}else if(type == 3){
							this.activeTab = '3'
						}else if(type == 4){
							if(!this.companyFormData.businessPhotoUrl){
								this.$message.warning('请上传营业执照！');
								return
							}
							if(this.companyFormData.certStatus === 0){
								if(this.companyDatePicker.length<=0){
									this.$message.warning('请选择证件有效期时间');
									return
								}
								this.companyFormData['certStartDate'] = this.companyDatePicker[0]
								this.companyFormData['certEndDate'] = this.companyDatePicker[1]
							}
							this.confirmCompanyInfo(this.companyFormData,1);
						}
					}
				})
			},
			async confirmCompanyInfo(formData,type = null){
				let data = formData;
				if(data.invoiceContent == 1){
					data['invoiceDiff'] = '0'
				}
				if(data.invoiceContent == 2){
					data['invoiceDiff'] = '1.5'
				}
				if(data.taxPoint == 1){
					data['valueAddDiff'] = '5'
				}
				if(data.taxPoint == 3){
					data['valueAddDiff'] = '3'
				}
				if(data.taxPoint == 6){
					data['valueAddDiff'] = '0'
				}
				let res = await this.$http.post(this.$api.companyAdd, data);
				if(res.code==1){
					if(type != 1){
						this.$message.success('保存成功');
						this.$router.go(-1);
					}else{
						this.confirmCompanyApproval(res.data.id);
					}
				}
			},
			async confirmCompanyApproval(companyId){
				let data = {companyId: companyId};
				let res = await this.$http.post(this.$api.approval.companySubmitExamine, data);
				if(res.code==1){
					this.$message.success('审核提交成功');
					this.$router.go(-1);
				}
			},
			// 媒体信息编辑确认
			confirmMedia(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						if(this.companyFormData.type=='INFORMATION_AD'){
							let isModelType = this.styleCheckList.some((items) => items.checked === true)
							if(!isModelType){
								this.$message.warning('请选择广告位模板');
								return
							}
						}
						let modelType = []
						this.styleCheckList.forEach((item,index) => {
							if(item.checked){
								modelType.push(index+1)
							}
						})
						// console.log(modelType);
						// return
						let data = this.companyFormData;
						data['modelType'] = modelType
						if(data.id){
							let res = await this.$http.post(this.$api.mediaAd.adsEdit, data);
							if(res.code ==1 ){
								this.$message.success('修改成功');
								this.closeMediaDialog();
							}
						}else{
							let res = await this.$http.post(this.$api.mediaAd.adsAdd, data);
							if(res.code ==1 ){
								this.$message.success('新增成功');
								this.closeMediaDialog();
							}
						}
						// this.getTableData();
					}
				});
			},
			checkChange(e, index) {
				let obj = this.styleCheckList[index]
				obj.checked = e
				this.$set(this.styleCheckList, index, obj)
			},
			
			uploadSetOther(){},
			handleBeforeUpload(file) {
				// 文件类型校验
				let fileExtension = "";
				if (file.name.lastIndexOf(".") > -1) {
					fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
				}
				// 校检文件大小
				if (this.fileSize) {
				  const isLt = file.size / 1024 / 1024 < this.fileSize;
				  if (!isLt) {
				    this.$message.warning(`上传文件大小不能超过 ${this.fileSize} MB!`);
				    return false;
				  }
				}
				const isTypeOk = this.fileType.some((type) => {
					// if (file.type.indexOf(type) > -1) return true;
					if (fileExtension && fileExtension.indexOf(type) > -1) return true;
					return false;
				});
				if (!isTypeOk) {
					this.$message.error(`文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`);
					return false;
				}
				return true
			},
			deletePoster() {
				this.companyFormData.businessPhotoUrl = ''
			},
			//上传图片**********营业执照
			async onChangeImg(file, fileList, type) {
				const fileExtension = file.name.split(".").pop().toLowerCase(); // 获取文件后缀名
				const isTypeOk = this.fileType.includes(fileExtension);
				if (!isTypeOk) {
					return false; // 阻止文件上传并移除
				}
				if(file.size / 1024 / 1024 > this.fileSize){
					return false
				}
				let formdata = new FormData;
				formdata.append('file', file.raw)
				let res = await this.$http.post(this.$api.common.uploadFile, formdata);
				if (res.code == 1) {
					if(type==1){
						this.companyFormData.businessPhotoUrl = res.data.url
						this.$forceUpdate();
					}
				}
			},
		},
	}
</script>

<style scoped>
	.headTabs {
		background: #FFFFFF;
		padding: 0 20px;
		margin: 10px;
		font-size: 16px;
	}
	/deep/ .el-tabs__header{
		margin-bottom: 0;
	}
	/* 使用 /deep/ 选择器覆盖 Element UI 的默认样式 */
	/deep/ .el-tabs__nav-wrap::after {
	  height: 0; /* 移除底部的边框线 */
	}
	/deep/ .el-tabs__item{
		height: 48px;
		line-height: 48px;
		color: #999999;
	}
	/deep/ .el-tabs__item.is-active{
		color: #007FFF;
	}
	.mianPage {
		margin: 10px;
		background: #FFFFFF;
		border-radius: 4px;
		padding: 24px;
		padding-bottom: 5px;
	}
	.titleRow{
		font-weight: 500;
		font-size: 17px;
		color: #333333;
		line-height: 22px;
		padding-left: 8px;
		border-left: 2px solid #4F7AFD;
	}
	.splitLine{
		width: 100%;
		height: 1px;
		background: #EEEEEE;
		margin-top: 12px;
		margin-bottom: 18px;
	}
	.el-form {
		/* margin-top: 24px; */
		/* flex-wrap: wrap; */
	}
	
	/deep/ .el-form--inline .el-form-item {
		margin-right: 20px !important;
	}
	/deep/ .el-select{
		width: 50%;
	}
	/deep/ .el-select>.el-input{
		width: 100%;
	}
	/deep/ .el-input{
		width: 50%;
	}
	.styleList{
		flex-wrap: wrap;
		width: 60%;
	}
	.styleCheckBox{
		border: 1px solid #F9F8F7;
		background: #F9F8F7;
		width: 242px;
		height: 90px;
		box-sizing: border-box;
		border-radius: 8px;
		padding: 0 13px;
		align-items: center;
		position: relative;
		cursor: pointer;
		margin-right: 12px;
		color: #333333;
		margin-top: 12px;
	}
	.styleCheckBox img{
		width: 64px;
		height: 64px;
	}
	.styleTxt{
		margin-left: 12px;
		font-weight: 600;
		font-size: 14px;
	}
	.checkContainer{
		position: absolute;
		right: -5px;
		top: 0px;
		z-index: 14;
		width: 242px;
		height: 92px;
	}
	.checkeds {
		position: absolute;
		right: 5px;
		top: 0px;
		z-index: 14;
	}
	.styleBoxActive{
		border: 1px solid #4F7AFD;
		background: #FFFFFF;
		color: #4F7AFD;
	}
	/* .styleTxtActive{
		color: #4F7AFD;
	} */
	.card-bottom {
		height: 64px;
		background: #FFFFFF;
		align-items: center;
		padding-right: 24px;
		margin: 10px;
	}
	/deep/.el-collapse-item__header{
		margin-left: 22px;
	}
	
	.upload-demo{
		margin-top: 8px;
	}
	.addImg{
		width: 120px;
		height: 120px;
		border: 1px dashed #eee;
		margin: 0px 0;
		align-items: center;
	}
	.addImg img{
		width: 20px;
		height: 20px;
	}
	.upload_img{
		width: 120px;
		height: 120px;
		margin: 0px 0;
		position: relative;
	}
	.closeImgIcon {
		position: absolute;
		right: -10px;
		top: -14px;
		height: 20px;
		width: 20px;
		cursor: pointer;
	}
	
	.closeImgIcon i {
		font-size: 20px;
	}
	.tipsIcon{
		align-items: center;
		padding-right: 12px;
	}
	.tipsIcon img{
		width: 16px;
		height: 16px;
		margin-right: 4px;
	}
	
	.auditStatus {
		align-items: center;
		font-weight: 500;
		font-size: 14px;
	}
	
	.statusLabel {
		width: 6px;
		height: 6px;
		border-radius: 50%;
		margin-right: 4px;
		background: #FA9600;
	}
	.rejectTxt{
		font-size: 12px;
		color: #333333;
		height: 24px;
		line-height: 24px;
		background: #FDF3F0;
		padding: 0 6px;
		border: 1px solid #FC474C;
		border-radius: 4px;
		box-sizing: border-box;
		margin-left: 5px;
	}
</style>